import React from "react";
import "./Navbar.css";
import logo from "./small.png";

const Navbar = () => {
  return (
    <div
      style={{
        backgroundColor: "white",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1050
      }}
      className="fixed top-0 left-0 w-full z-50 bg-white"
      id="navbar-border"
    >
      <nav
        id="navbar-border1"
        className="navbar navbar-expand-lg"
        style={{ backgroundColor: "white" }}
      >
        <div className="container pt-2 fw-medium d-flex align-itmes-center">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="navbar-brand d-flex align-items-center gap-2 border-0 bg-transparent p-0"
          >
            <img
              src={logo}
              alt="Logo"
              height="40"
              width="auto"
              className="d-inline-block align-text-top"
            />
            <span
              className="fw-bold fs-3"
              style={{
                background:
                  "linear-gradient(40deg, #6953d3, #8566f1, #a14eee, #f98085)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                display: "inline-block"
              }}
            >
              Amar Net Bill
            </span>
          </button>

          <div className="flex gap-4">
            <button className="btn btn-primary download">Download App</button>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
